import styled from 'styled-components';

import { ButtonStyled } from '../../../../components/Button/Button.styled';
import { SingleButtonWrapperStyled } from '../../HomePage.styled';

export const LogoStyled = styled.img`
  display: block;
  max-height: 60px;
  margin: 20px 0;
`;

export const EchoImgStyled = styled.img`
  display: block;
  width: 140px;
  margin: 20px 0;
`;

export const FaqButtonWrapperStyled = styled(SingleButtonWrapperStyled)`
  ${ButtonStyled} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 40px;
  }
`;
